import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';
import { analytics } from './analytics/analytics';
import { errorReports } from './errorReports/errorReports';
import { UserIdentity } from './telemetry.type';

export const telemetryInit = (): void => {
  analytics.init();
  errorReports.init();
};

export const telemetryIdentifyUser = (user: UserIdentity): void => {
  datadogRum.setUser({ ...user });
  datadogLogs.setUser({ ...user });
  analytics.identifyUser(user);
  errorReports.identifyUser(user);
};

export { analytics, errorReports };
